import type { PaginatedResponse } from "@/types/common.types";

export interface Commodity {
  id: string;
  appleProductId: string;
  name: string;
  price: number;
  status: CommodityStatus;
  duration: number; // 会员时长
  unit: CommodityUnit; // 时长单位
  image?: string; // 商品图
  description: string; // 商品描述
  platform?: string;
  createdAt?: string;
  updateAt?: string;
}

export interface CommodityCommitedByActivity {
  id: string; // 关联记录的唯一ID
  activity_id: string; // 所属活动的ID
  product_id: string; // 商品ID

  // 关键：设为可选。/activity/list 接口不返回此字段，但在编辑弹窗中需要手动填充
  product_name?: string;

  original_price: number; // 商品原价 (单位：分)
  activity_price: number; // 商品活动价 (单位：分)

  gift_name: string; // 赠品名
  gift_type: number; // 赠品类型
  gift_duration: number; // 赠送时长
  gift_unit: string; // 赠品时长单位
  gift_price: number; // 赠品价格 (单位：分)

  createdAt: string; // 关联记录的创建时间
}

// 用于状态下拉框的选项
export const STATUS_OPTIONS = [
  { value: "all", label: "全部" },
  { value: "active", label: "使用中" },
  { value: "inactive", label: "下架" },
];
export const UNIT_OPTIONS = [
  { value: "year", label: "年" },
  { value: "month", label: "月" },
];
export const GIFT_OPTIONS = [
  { value: 0, label: "未赠送" },
  { value: 1, label: "会员时长" },
  { value: 2, label: "积分" },
  { value: 3, label: "优惠券" },
  { value: 4, label: "实物" },
];
export const GIFT_TYPE = {
  0: "未赠送",
  1: "会员时长",
  2: "积分",
  3: "优惠券",
  4: "实物",
};

// 课程状态：1-使用中，2-下架
export type CommodityStatus = "active" | "inactive";
export type CommodityUnit = "year" | "month";
export type GiftType = 0 | 1 | 2 | 3 | 4;

export type CommoditiesResponse = PaginatedResponse<Commodity>;

export type GetCommoditiesParams = {
  page: number;
  page_size: number;

  // platform: string;

  // 查询条件
  // title?: string; // 课程名称

  // 状态筛选
  status?: CommodityStatus | "all";
  // unit: string;
};
